type Props = { message: string; onDismiss?: () => void };

export function ErrorBanner({ message, onDismiss }: Props) {
  return (
    <div style={{
      background: "rgba(255,77,77,0.12)",
      border: "1px solid rgba(255,77,77,0.3)",
      borderRadius: 4,
      color: "#ff4d4d",
      fontSize: 14,
      padding: "12px 16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
    }}>
      <span>{message}</span>
      {onDismiss && (
        <button
          onClick={onDismiss}
          style={{ background: "none", border: "none", color: "#ff4d4d", cursor: "pointer",
            fontSize: 18, minHeight: "unset", padding: "0 4px" }}
        >×</button>
      )}
    </div>
  );
}
